import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {
  Aangifte, AangifteBerekening,
  AangifteRapport, BokkzAlgDataService, Box1Berekening, IncomeTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {
  OverzichtWinstUitOndernemingComponent
} from '../wuo/overzicht-winst-uit-onderneming/overzicht-winst-uit-onderneming.component';
import { OverzichtLoonComponent } from '../overzicht-loon/overzicht-loon.component';
import {
  OverzichtResultaatOverigeWerkzaamhedenComponent
} from '../overzicht-resultaat-overige-werkzaamheden/overzicht-resultaat-overige-werkzaamheden.component';
import {
  OverzichtPeriodiekeUitkeringenComponent
} from '../overzicht-periodieke-uitkeringen/overzicht-periodieke-uitkeringen.component';
import { OverzichtEigenWoningComponent } from '../overzicht-eigen-woning/overzicht-eigen-woning.component';
import { OverzichtLijfrenteComponent } from '../overzicht-lijfrente/overzicht-lijfrente.component';
import {
  OverzichtNegInkomensvoorzieningComponent
} from '../overzicht-neg-inkomensvoorziening/overzicht-neg-inkomensvoorziening.component';
import { OverzichtNegPgaComponent } from '../overzicht-neg-pga/overzicht-neg-pga.component';
import {
  OverzichtVerliescompensatieBox1Component
} from '../overzicht-verliescompensatie-box1/overzicht-verliescompensatie-box1.component';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-overzicht-inkomen-box1',
  templateUrl: './overzicht-inkomen-box1.component.html',
  styleUrls: ['./overzicht-inkomen-box1.component.scss'],
  imports: [
    OverzichtWinstUitOndernemingComponent,
    OverzichtLoonComponent,
    OverzichtResultaatOverigeWerkzaamhedenComponent,
    OverzichtPeriodiekeUitkeringenComponent,
    OverzichtEigenWoningComponent,
    OverzichtLijfrenteComponent,
    OverzichtNegInkomensvoorzieningComponent,
    OverzichtNegPgaComponent,
    OverzichtVerliescompensatieBox1Component,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class OverzichtInkomenBox1Component implements OnInit {

  @Input() public id!: string;
  @Input() partner = new BehaviorSubject<boolean>(false);
  public aangifte = {} as Aangifte;
  public incomeTaxEntity = {} as IncomeTaxEntity;
  public partnerBoolean = {} as boolean;
  public hasVerdelingGezien = false;
  public aangifteRapport = {} as AangifteRapport;
  public partnerRapport = {} as AangifteRapport;
  public berekening = {} as AangifteBerekening;
  public partnerBerekening = {} as AangifteBerekening;
  public isDefAangifte = {} as boolean;
  public specInkomenBox1 = {} as AangifteRapport;
  public specInkomenBox1Partner = {} as AangifteRapport;
  public berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

  public hasAangeverWinst(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.winstUitOnderneming != undefined);
  }

  public hasAangeverLoon(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.belastbaarloon != undefined);
  }

  public hasAangeverRow(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.resultaatUitOverigeWerkzaamheden != undefined);
  }

  public hasAangeverPerUitk(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.periodiekeUitkeringen != undefined);
  }

  public hasAangeverEigenWoning(): boolean {
    return !!(this.aangifte && this.aangifte.box1 && this.aangifte.box1.belastbareInkomstenUitEigenWoning);
  }

  public hasAangeverLijfrente(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.uitgavenVoorInkomensvoorzieningen != undefined);
  }

  public hasAangeverNegatieveLijfrente(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.negatieveUitgavenVoorInkomensvoorzieningen != undefined);
  }

  public hasAangeverNegatievePga(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1?.opbouwInkomen?.negatievePersoonsgebondenAftrek != undefined);
  }

  hasAangeverVerrekendVerliesBox1(): boolean {
    return !!(this.berekening && this.berekening.box1 && this.berekening.box1.opbouwInkomen && this.berekening.box1.opbouwInkomen?.verrekendVerlies);
  }

  public hasPartnerWinst(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.winstUitOnderneming);
  }

  public hasPartnerLoon(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.belastbaarloon);
  }

  public hasPartnerRow(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.resultaatUitOverigeWerkzaamheden);
  }

  public hasPartnerPerUitk(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.periodiekeUitkeringen);
  }

  public hasPartnerEigenWoning(): boolean {
    return !!(this.aangifte && this.aangifte.box1 && this.aangifte.box1.belastbareInkomstenUitEigenWoning && this.aangifte.box1.belastbareInkomstenUitEigenWoning.eigenWoningen);
  }


  public hasPartnerLijfrente(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.uitgavenVoorInkomensvoorzieningen);
  }

  public hasPartnerNegatieveLijfrente(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 && this.berekening.partnerBerekening.box1?.opbouwInkomen?.negatieveUitgavenVoorInkomensvoorzieningen != undefined);
  }

  public hasPartnerNegatievePga(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 && this.berekening.partnerBerekening.box1?.opbouwInkomen?.negatievePersoonsgebondenAftrek != undefined);
  }

  hasPartnerVerrekendVerliesBox1(): boolean {
    return !!(this.berekening && this.berekening.partnerBerekening && this.berekening.partnerBerekening.box1 &&
      this.berekening.partnerBerekening.box1.opbouwInkomen && this.berekening.partnerBerekening.box1.opbouwInkomen?.verrekendVerlies);
  }

  constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder, private cdRef: ChangeDetectorRef) {
    this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
      box1: this.fb.group<Box1Berekening>(({
        inkomen: null as unknown as number,
      } as Box1Berekening)),
    } as AangifteBerekening))
  }

  public ngOnInit(): void {
    this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
      this.incomeTaxEntity = incomeTaxEntity;
      if (incomeTaxEntity.aangifte) {
        this.aangifte = incomeTaxEntity.aangifte as Aangifte;
        this.cdRef.markForCheck();
      }
    });
    this.dataService.aangifteBerekening.subscribe((aangifteBerekening) => {
      this.berekening = aangifteBerekening;
      this.specInkomenBox1 = this.aangifteRapport
      this.berekeningBox1FormGroup.reset()
      this.berekeningBox1FormGroup.patchValue(this.berekening)
      if (aangifteBerekening.partnerBerekening) {
        this.partnerBerekening = aangifteBerekening.partnerBerekening;
      }
    });
    this.dataService.hasVerdelingGezien.subscribe((gezien) => {
      this.hasVerdelingGezien = gezien;
    });
    this.partner.subscribe((partner) => {
      this.partnerBoolean = partner
      if (this.partnerBoolean) {
        this.specInkomenBox1 = this.partnerRapport;
        if (this.berekening.partnerBerekening) {
          this.berekeningBox1FormGroup.reset()
          this.berekeningBox1FormGroup.patchValue(this.berekening.partnerBerekening)
        }
      }
      if (!this.partnerBoolean) {
        this.specInkomenBox1 = this.aangifteRapport;
        this.berekeningBox1FormGroup.reset()
        this.berekeningBox1FormGroup.patchValue(this.berekening)
      }
      this.cdRef.markForCheck();
    })
    this.dataService.aangifteRapport.subscribe((aangifteRapport) => {
      this.aangifteRapport = aangifteRapport;
      this.cdRef.markForCheck();
    });
    this.dataService.partnerAangifteRapport.subscribe((partnerRapport) => {
      if (partnerRapport) {
        this.partnerRapport = partnerRapport;
        this.specInkomenBox1Partner = partnerRapport;
        this.cdRef.markForCheck();
      }
    })
  }
}


